import { configureStore } from '@reduxjs/toolkit';
import pageSliceReducer from '../redux/settings/page-settings-slice';
import searchOptionsSliceReducer from '../redux/search/search-slice';
import { apiSlice } from '../redux/api-slice';

export const store = configureStore({
    reducer: {
        pageSettings: pageSliceReducer,
        searchOptions: searchOptionsSliceReducer,
        [apiSlice.reducerPath]: apiSlice.reducer,
    },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(apiSlice.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
